<template>
  <base-section id="features" class="secondary">
    <v-responsive class="mx-auto" max-width="1350">
      <v-container fluid>
        <h1
          class="text-uppercase headline font-weight-bold mb-2 text-center white--text"
        >
          Our Great Values
        </h1>

        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card align="center" dark v-bind="card" />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeatures",

  data: () => ({
    cards: [
      {
        color: "orange",
        icon: "mdi-home",
        title: "Regular In-House Training",
        text:
          "Provided to every of our team regularly by the experience supervisor/trainer."
      },
      {
        color: "orange",
        icon: "mdi-human-male-board",
        title: "On-Job Training",
        text:
          "Regular follow up with the team when they are on the job, to provide further guidance."
      },
      {
        color: "orange",
        icon: "mdi-book",
        title: "External Training",
        text:
          "Enhanced Training provided by the training centre or professionals."
      },
      {
        color: "orange",
        icon: "mdi-human-male-board-poll",
        title: "Advisory & Consultation",
        text:
          "Regular care to our team for their well-being so that they are able to provide its best service at work."
      }
    ]
  })
};
</script>
